import {Component, isDevMode, OnInit} from '@angular/core';
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Observable} from "rxjs";
import {environment} from "../../../../../environments/environment";
import {collection, Firestore, query, where} from "@angular/fire/firestore";

@Component({
  selector: 'app-education-mix-session-report',
  templateUrl: './education-mix-session-report.component.html',
  styleUrls: ['./education-mix-session-report.component.scss']
})
export class EducationMixSessionReportComponent implements OnInit {
  startDate: Date | undefined
  endDate: Date | undefined
  // raportSessions$: Observable<any>
  env = isDevMode() ? environment.testMode : environment.productionMode

  constructor(
    private readonly mFirestore: AngularFirestore,
    private firestore: Firestore,
  ) {
//definging collection here
//       let educationCollection = collection(this.firestore,this.env.education)
// const rapportquery = query(educationCollection,where('sessionType','==','Rapport Building')

// )

    // this.raportSessions$ = this.mFirestore.collection(this.env.education, ref => ref
    //   .where('sessionType', '==', 'Rapport Building')).get()

// this.mFirestore.collection(this.env.educationGroup,ref => ref.where('volunteerName','==','Tss'))
//   .get().subscribe(res=>{
//     let count =0
//     // alert(res.docs.length)
// // res.docs.forEach(doc=>{
// //   this.mFirestore.collection(this.env.educationGroup).doc(doc.id).update({'countType':'bychildren'}).then(()=>{
// //     count++
// //     console.log('updated docs'+count)
// //   })
// // })
//   })

  }

  ngOnInit(): void {


  }

}
